import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ContractListComponent from './ContractListComponent';
import ContractSelectionFiltersComponent from './ContractSelectionFiltersComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { BoxActionsWrapper } from 'components/common/CommonStyles';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import PaginationWrapper from 'components/common/PaginationWrapper';

const ContractSelectionComponent = ({
  t,
  showContractSelection,
  onCloseContractSelectionModal,
  loadLeasingContractList,
  filters,
  onChangeFilterValue,
  leasingContractList,
  contractSelected,
  onChangePage,
  isLoading,
  onSelectContract,
  onRefreshList,
  pagination,
  totalCount
}) => {
  return (
    <Dialog
      open={showContractSelection}
      aria-labelledby='contractList-dialog-title'
      maxWidth={'lg'}
      fullWidth
      onClose={onCloseContractSelectionModal}
      title={t('RestructuringEdit.ContractSelection.Title')}
      content={
        <>
          <ContractSelectionFiltersComponent
            filters={filters}
            onChangeFilterValue={onChangeFilterValue}
            loadLeasingContractList={loadLeasingContractList}
          />
          {isLoading ? (
            <WrappedFakeText lines={6} />
          ) : (
            <ContractListComponent
              leasingContractList={leasingContractList}
              contractSelected={contractSelected}
              onSelectContract={onSelectContract}
              onCloseContractSelectionModal={onCloseContractSelectionModal}
            />
          )}
          {leasingContractList && leasingContractList.length > 0 && (
            <PaginationWrapper
              loading={false}
              count={totalCount}
              pageSize={pagination.pageSize}
              page={pagination.page}
              onPageChange={onChangePage}
              onRefresh={onRefreshList}
              rowsPerPageOptions={[]}
            />
          )}
        </>
      }
      actions={
        <BoxActionsWrapper forDialog>
          <Button id={'contractSelection_closeBtn'} onClick={onCloseContractSelectionModal}>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

ContractSelectionComponent.propTypes = {
  t: PropTypes.func.isRequired,
  showContractSelection: PropTypes.bool,
  onCloseContractSelectionModal: PropTypes.func,
  loadLeasingContractList: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  leasingContractList: PropTypes.array,
  contractSelected: PropTypes.object.isRequired,
  onChangePage: PropTypes.func,
  isLoading: PropTypes.bool,
  onSelectContract: PropTypes.func,
  onRefreshList: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired
};

export default withTranslation()(ContractSelectionComponent);
